import { inject, Pipe, PipeTransform } from '@angular/core';
import { AnalysisStateService } from '../services';
import { AnalysisCostType } from '@marmon/shared/types/analysis';

@Pipe({
	name: 'isCostType',
	standalone: true,
})
export class IsCostTypePipe implements PipeTransform {
	readonly analysisStateService = inject(AnalysisStateService);

	/**
	 * Determines if the provided cost type is the same cost type that is currently being loaded
	 * in by the analysis.
	 *
	 * @param type type of cost t check against 'material' | 'direct'
	 * @returns boolean depicting if the current cost type is equal to requested one
	 */
	transform(type: AnalysisCostType) {
		const costType = this.analysisStateService.analysis?.costType;
		if (!costType) return false;
		return type === costType;
	}
}
